import { GetUploadFileTypesResponse, UploadFileType, UploadFileTypes } from '../types'

function mapUploadFileType(response: Partial<UploadFileType> = {}): UploadFileType {
  return {
    id: response.id || 0,
    name: response.name || '',
  }
}

function mapUploadFileTypes(response: Partial<GetUploadFileTypesResponse> = []): UploadFileTypes {
  return response?.map((item) => mapUploadFileType(item)) || []
}

const mappers = { mapUploadFileType, mapUploadFileTypes }

export default mappers
